/* eslint-disable fp/no-this */
import type { SyntheticEvent } from 'react'
import { useState } from 'react'
import classes from './InputFile.module.scss'

interface Data {
  file: File
  content: string
}

export interface Props {
  acceptedFileTypes: string[]
  isDisplayFileName?: boolean
  onChange: (fileData: Data) => void
  label: string
}

const InputFile = ({
  acceptedFileTypes,
  isDisplayFileName = true,
  onChange,
  label
}: Props) => {
  const [fileName, setFileName] = useState('')

  const reader = new FileReader()

  const handleFileChange = (event: SyntheticEvent) => {
    const target = event.target as HTMLInputElement

    // A cancelled file dialog will trigger a change without providing a file
    const file = (target.files as FileList)[0] as (File | undefined)

    if (file) {
      reader.onload = function () {

        onChange({
          file,
          content: this.result as string
        })
        setFileName(file.name)
      }
      reader.readAsText(file)
    }
  }

  // Check the SCSS for the layout reasoning
  return (
    <span className={classes.InputFile}>
      <label>
        <span>
          {label}
        </span>
        <input
          accept={acceptedFileTypes.join(', ')}
          className={classes.InputFile}
          onChange={handleFileChange}
          type='file'
        />
      </label>
      {
        fileName && isDisplayFileName &&
          <span aria-hidden>
            {fileName}
          </span>
      }
    </span>
  )
}

export default InputFile
